import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import MyDialog from '@/components/MyDialog.vue';
import { chain } from 'lodash';
import CharacterSheetExpansionFeatures from './CharacterSheetExpansionFeatures.vue';
import MySelect from '@/components/MySelect.vue';
const maneuversModule = namespace('maneuvers');
let CharacterSheetCastingAddManeuver = class CharacterSheetCastingAddManeuver extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.typeFilter = [];
    }
    created() {
        this.fetchManeuvers();
    }
    get filteredManeuvers() {
        return chain(this.maneuvers)
            .filter(({ type }) => (!this.typeFilter.length || this.typeFilter.includes(type)))
            .sortBy(({ name }) => this.maneuversSelected.includes(name) ? -1 : 0)
            .value();
    }
    toggleManeuver(maneuverName) {
        const isSelected = this.maneuversSelected.includes(maneuverName);
        const maneuversWithoutNew = this.maneuversSelected.filter(maneuver => maneuver !== maneuverName);
        const maneuversWithNew = this.maneuversSelected.concat(maneuverName);
        this.$emit('updateManeuvers', isSelected ? maneuversWithoutNew : maneuversWithNew);
    }
};
__decorate([
    Prop(Boolean)
], CharacterSheetCastingAddManeuver.prototype, "icon", void 0);
__decorate([
    Prop(Boolean)
], CharacterSheetCastingAddManeuver.prototype, "disabled", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCastingAddManeuver.prototype, "maneuversSelected", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], CharacterSheetCastingAddManeuver.prototype, "allManuevers", void 0);
__decorate([
    maneuversModule.State
], CharacterSheetCastingAddManeuver.prototype, "maneuvers", void 0);
__decorate([
    maneuversModule.Action
], CharacterSheetCastingAddManeuver.prototype, "fetchManeuvers", void 0);
CharacterSheetCastingAddManeuver = __decorate([
    Component({
        components: {
            CharacterSheetExpansionFeatures,
            MyDialog,
            MySelect
        }
    })
], CharacterSheetCastingAddManeuver);
export default CharacterSheetCastingAddManeuver;
